import React from "react";
import { StyledHeaderImage, StyledHeader, StyledDiv, StyledWrapper } from "./style";

interface Props {
  imageLink: string;
  alt: string;
  header: string;
}

const HeaderImage: React.FC<Props> = ({ imageLink, alt, header }) => {
  return (
    <StyledDiv>
      <StyledHeader style={{ color: "white" }}>{header}</StyledHeader>
      <StyledWrapper>
        <StyledHeaderImage src={imageLink} alt={alt} />
      </StyledWrapper>
    </StyledDiv>
  );
};

export default HeaderImage;
